import React from "react";
import { FaInfoCircle } from "react-icons/fa";

function KpiCard({ title, value, sub, icon, color, bgcolor, tooltip }) {
  return (
    <div className="bg-white p-5 rounded-xl shadow flex justify-between items-center hover:shadow-md transition-shadow">
      <div>
        <div className="flex items-center gap-2">
          <p className="text-gray-500 text-sm">{title}</p>
          {tooltip && (
            <span className="text-gray-400 hover:text-gray-600 cursor-help">
              <div className="text-xs sm:text-sm text-gray-500  flex items-center gap-2 group relative flex-wrap">
                <FaInfoCircle className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 group-hover:text-indigo-600 cursor-pointer flex-shrink-0" />

                <div
                  className="absolute left-0 top-6 z-10
        hidden group-hover:block
        bg-black text-white text-xs px-2 py-1 rounded shadow-md w-max max-w-[200px] sm:max-w-none"
                >
                  {tooltip}
                </div>
              </div>
            </span>
          )}
        </div>
        <p className={`text-2xl font-bold ${color}`}>{value}</p>
        {sub && <p className="text-xs text-gray-400">{sub}</p>}
      </div>
      <div className={` text-xl ${color} ${bgcolor}`}>{icon}</div>
    </div>
  );
}

export default KpiCard;
